/**
 * fSpy
 * Copyright (c) 2020 - Per Gantelius
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { ActionTypes, AppAction } from '../actions'
import { UIState } from '../types/ui-state'
import { defaultUIState } from '../defaults/ui-state'

export function uiState(state: UIState | undefined, action: AppAction): UIState {
  if (state === undefined) {
    return defaultUIState
  }

  // TODO: move these ipc calls somewhere else?

  switch (action.type) {
    case ActionTypes.SET_SIDE_PANEL_VISIBILITY:
      return {
        ...state,
        sidePanelsAreVisible: action.panelsAreVisible
      }
  }

  return state
}
